import { v4 as generateID } from '@lukeed/uuid';
export function joinRanges(ranges) {
    ranges.sort((a, b) => a.from - b.from);
    for (let i = 0; i < ranges.length - 1; i++) {
        const currentRange = ranges[i];
        const nextRange = ranges[i + 1];
        if (currentRange.to > nextRange.from) {
            currentRange.id = generateID();
            currentRange.to = Math.max(nextRange.to, currentRange.to);
            if (currentRange.signals && nextRange.signals) {
                currentRange.signals = currentRange.signals.concat(nextRange.signals);
            }
            if (currentRange.integration !== undefined) {
                currentRange.integration += nextRange.integration || 0;
            }
            ranges.splice(i + 1, 1);
            i--;
        }
    }
    return ranges;
}
//# sourceMappingURL=joinRanges.js.map